import React from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

const PayPalButton = ({ amount, onSuccess, onError, txnBookingID, purchaseItems}) => {

  const clientId ='AUoU2zPnUlA9vn3hmmcYVXqxQfAd-ljeA_fX7P2UBpy48cand0B9HlrPt9kNDL_4sebHfUBqUdzKMz77';
  // 'AUoU2zPnUlA9vn3hmmcYVXqxQfAd-ljeA_fX7P2UBpy48cand0B9HlrPt9kNDL_4sebHfUBqUdzKMz77' -Actual
  // 'AcFd96iWuJ8ifRn9v9uzuXEEc3fj46Vzap8n_6AGl1MUzJb_c78NPMYdY9ZZTY9sP4dHgOZAk4ZoZdwG'; // Replace with your actual client ID
  //'ASs41FR5MYsB1xrKHJTqECymjfx9FgDq0D3HavqDEA5VZAxCVhXM5AJJ-sGwlue5T1mocpavz2pYMBZm'

  return (
    <PayPalScriptProvider options={{ "client-id": clientId,"currency":"AUD" }}>
      <PayPalButtons
        createOrder={(data, actions) => {
          return actions.order.create({
            "intent": "CAPTURE",
            "purchase_units": [{
              "reference_id": txnBookingID,
              "amount": {
                "currency_code": "AUD",
                "value": amount,
                "breakdown": {
                  "item_total": {
                    "currency_code": "AUD",
                    "value": amount
                  }
                }
              },
              "items": [...purchaseItems]
            }],
             application_context: {
                shipping_preference: "NO_SHIPPING"
            }
          });
        }}
        onApprove={(data, actions) => {
          // Capture the funds
          return actions.order.capture().then(function (details) {
            onSuccess(details);
          });
        }}
        onError={(error) => {
          console.error(error);
          // Execute the callback function to handle errors
          onError(error);
        }}
      />
    </PayPalScriptProvider>
  );
};

export default PayPalButton;
